import { gql } from '@apollo/client';
import { ASSESSMENT_FIELDS } from '../../fragments/assessment';
import { CreateAssessmentProps, UpdateAssessmentProps } from './assessment.types';
import { AssessmentType } from '../../../types';
import {
  GET_ASSESSMENTS_BY_REFERENCE_ID,
  GET_ASSESSMENT_BY_ASSESSMENT_ID,
} from '../../queries';

export const CREATE_ASSESSMENT = gql`
  ${ASSESSMENT_FIELDS}
  mutation createAssessment(
  $approverId: ID,
  $referenceId: ID,
  $rating: Int!,
  $completedTasks: String!,
  $incompleteTasks: String!,
  $improvementOpportunities: String!,
  $assessmentStatus: String
  ) {
    createAssessment(
    approverId: $approverId,
    completedTasks: $completedTasks,
    referenceId: $referenceId,
    incompleteTasks: $incompleteTasks,
    assessmentStatus: $assessmentStatus,
    rating: $rating,
    improvementOpportunities: $improvementOpportunities,
    ){
      ...AssessmentFields
    }
  }
`;

export function createAssessment({
  client,
  referenceId,
  approverId,
  rating,
  completedTasks,
  incompleteTasks,
  improvementOpportunities,
  assessmentStatus,
}: CreateAssessmentProps) {
  return client?.mutate<{ createAssessment: AssessmentType }>({
    mutation: CREATE_ASSESSMENT,
    variables: {
      referenceId,
      approverId,
      rating,
      completedTasks,
      incompleteTasks,
      improvementOpportunities,
      assessmentStatus,
    },
    refetchQueries: [
      GET_ASSESSMENTS_BY_REFERENCE_ID,
    ],
  });
}

export const UPDATE_ASSESSMENT = gql`
  ${ASSESSMENT_FIELDS}
  mutation UpdateAssessment(
  $assessmentId: ID!,
  $rating: Int,
  $completedTasks: String,
  $incompleteTasks: String,
  $improvementOpportunities: String,
  ){
    updateAssessment(
    assessmentId: $assessmentId,
    rating: $rating,
    completedTasks: $completedTasks,
    incompleteTasks: $incompleteTasks,
    improvementOpportunities: $improvementOpportunities,
    ){
      ...AssessmentFields
    }
  }
`;

export function updateAssessment({
  client,
  assessmentId,
  rating,
  completedTasks,
  incompleteTasks,
  improvementOpportunities,
}: UpdateAssessmentProps) {
  return client?.mutate<{ updateAssessment: AssessmentType }>({
    mutation: UPDATE_ASSESSMENT,
    variables: {
      assessmentId,
      rating,
      completedTasks,
      incompleteTasks,
      improvementOpportunities,
    },
    refetchQueries: [
      GET_ASSESSMENT_BY_ASSESSMENT_ID,
    ],
  });
}

export const CREATE_MANAGER_ASSESSMENT = gql`
  ${ASSESSMENT_FIELDS}
  mutation createManagerAssessment(
  $approverId: ID,
  $referenceId: ID,
  $rating: Int!,
  $completedTasks: String!,
  $incompleteTasks: String!,
  $improvementOpportunities: String!,
  $assessmentStatus: String
  ) {
    createManagerAssessment(
    approverId: $approverId,
    completedTasks: $completedTasks,
    referenceId: $referenceId,
    incompleteTasks: $incompleteTasks,
    assessmentStatus: $assessmentStatus,
    rating: $rating,
    improvementOpportunities: $improvementOpportunities,
    ){
      ...AssessmentFields
    }
  }
`;

export function createManagerAssessment({
  client,
  referenceId,
  approverId,
  rating,
  completedTasks,
  incompleteTasks,
  improvementOpportunities,
  assessmentStatus,
}: CreateAssessmentProps) {
  return client?.mutate<{ createManagerAssessment: AssessmentType }>({
    mutation: CREATE_ASSESSMENT,
    variables: {
      referenceId,
      approverId,
      rating,
      completedTasks,
      incompleteTasks,
      improvementOpportunities,
      assessmentStatus,
    },
    refetchQueries: [
      GET_ASSESSMENTS_BY_REFERENCE_ID,
    ],
  });
}
